import type { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';

interface GuestGuardProps {
  children: ReactNode;
  isAuthenticated: boolean;
}

const GuestGuard: FC<GuestGuardProps> = ({ children, isAuthenticated }) => {
  if (isAuthenticated) {
    return <Navigate to="/admin" />;
  }

  return <>{children}</>;
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {})(GuestGuard);
